// Shared route names — used across ≥2 screens or by app-shell hubs (navs, layouts,
// router, boot). Single-screen route names live in `pages/<slug>/consts.ts` instead
// (#878). Route names are plain consts, so they belong in `consts/`, not `enums/`.

export const AUTH_ROUTE_NAME = {
  SIGNUP: 'signup',
  SIGNIN: 'signin',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  VERIFY_EMAIL: 'verify-email',
  STAFF_LOGIN: 'staff-login'
};

export const EMPLOYEE_ROUTE_NAME = {
  LIST_EMPLOYEE: 'list-employee',
  PICK_EMPLOYEES: 'pick-employees',
};

export const USER_ROUTE_NAME = {
  PROFILE: 'profile',
};

export const BOOK_APPOINTMENT_ROUTE_NAME = {
  BOOK_APPOINTMENT: 'book-appointment',
  CREATE_APPOINTMENT: 'create-appointment',
};

export const CUSTOMER_REVIEW_ROUTE_NAME = {
  CUSTOMER_REVIEW: 'customer-review',
};

export const REVIEW_ROUTE_NAME = {
  LIST_REVIEW: 'list-review',
};

export const TURN_TRACKER_ROUTE_NAME = {
  TURN_TRACKER: 'turn-tracker',
};

export const CUSTOMER_MGMT_V2_ROUTE_NAME = {
  CUSTOMER_MGMT_V2: 'customer-mgmt-v2',
};

export const SERVICE_ROUTE_NAME = {
  LIST_SERVICE: 'list-service',
};

export const STORE_ROUTE_NAME = {
  ADD_STORE: 'add-store',
  ONBOARDING_STORE: 'onboarding-store',
};

export const PROMOTION_BANNER_ROUTE_NAME = {
  PROMOTION_BANNER: 'promotion-banner',
};

export const CUSTOMER_ROUTE_NAME = {
  CUSTOMER_CHECKIN: 'customer-checkin',
  CUSTOMER_CHECKOUT: 'customer-checkout',
  LIST_CUSTOMER_CHECKIN: 'list-customer-checkin',
};

export const SETUP_ROUTE_NAME = {
  SETUP: 'setup',
  STORE_SETTINGS: 'store',
  PAYMENT_METHOD_MANAGEMENT: 'payment-method-management',
  ADMIN: 'admin',
  // Values kept as legacy route names — setup/route.ts redirects by name, not path.
  CHECKOUT_SETUP: 'checkout-setup',
  TURN_TRACKER_SETUP: 'turn-tracker-setup',
  STORE_LANDING: 'store-landing',
};

// Hub-level (#878): the left drawer is a second consumer alongside the screen's own route.ts.
export const PROMOTION_MANAGEMENT_ROUTE_NAME = {
  PROMOTION_MANAGEMENT: 'promotion-management',
};

export const BANNER_MANAGEMENT_ROUTE_NAME = {
  BANNER_MANAGEMENT: 'banner-management',
};

export const REPORT_ROUTE_NAME = {
  REPORT: 'report',
};

export const GIFTCARD_ROUTE_NAME = {
  GIFTCARD: 'gift-card',
};

export const DEVICE_MANAGEMENT_ROUTE_NAME = {
  DEVICE_MANAGEMENT: 'device-management',
};

export const SPIN_CAMPAIGN_ROUTE_NAME = {
  SPIN_CAMPAIGN: 'spin-campaign',
  SPIN_CAMPAIGN_CREATE: 'spin-campaign-create',
  SPIN_CAMPAIGN_EDIT: 'spin-campaign-edit',
  SPIN_CAMPAIGN_DETAIL: 'spin-campaign-detail',
  SPIN_CUSTOMER: 'spin-customer',
};
